"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { keyframes } from "tss-react";
import makeStyles from "../../theming/make-styles.js";
const sizeStyle = {
    small: 4,
    medium: 8,
    large: 16,
};
const indeterminateFirst = keyframes `
  from {
    left: -100%;
    width: 100%;
  }
  to {
    left: 100%;
    width: 10%;
  }
`;
const indeterminateSecond = keyframes ` 
  from {
    left: -150%;
    width: 100%;
  } 
  to {
    left: 100%;
    width: 10%;
  }
`;
const useStyles = makeStyles()((theme, { color, round, size, value }) => {
    const palette = theme.palette(color).linearProgress;
    return {
        indeterminate: {
            "&::before, &::after": {
                content: "''",
                position: "absolute",
                height: "100%",
            },
            "&::before": {
                backgroundColor: palette.indeterminate.before.backgroundColor,
                animation: `${indeterminateFirst} 1.5s infinite ease-out`,
            },
            "&::after": {
                backgroundColor: palette.indeterminate.after.backgroundColor,
                animation: `${indeterminateSecond} 1.5s infinite ease-in`,
            },
        },
        progress: {
            width: `${value}%`,
            height: "inherit",
            backgroundColor: palette.progress.backgroundColor,
        },
        rail: {
            position: "relative",
            width: "100%",
            height: theme.spacing(sizeStyle[size]),
            backgroundColor: palette.rail.backgroundColor,
            borderRadius: round ? theme.size(9999) : undefined,
            overflow: "hidden",
        },
    };
});
export function LinearProgress(_a) {
    var { className, color = "primary", indeterminate = false, round, size = "small", value = 0 } = _a, props = __rest(_a, ["className", "color", "indeterminate", "round", "size", "value"]);
    const { classes, cx } = useStyles({ color, indeterminate, round, size, value });
    return (_jsx("div", { className: cx(classes.rail, className), "data-component": "linear-progress", children: _jsx("div", Object.assign({ "aria-valuemax": 100, "aria-valuemin": 0, "aria-valuenow": value, className: cx({
                [classes.indeterminate]: indeterminate,
                [classes.progress]: !indeterminate && typeof value === "number" && !Number.isNaN(value) && value >= 0 && value <= 100,
            }), role: "progressbar" }, props)) }));
}
export default LinearProgress;
//# sourceMappingURL=linear-progress.js.map